import { Layout } from "../../layout/page";
import { InventoryTypeDetailContent } from "../../content/inventoryType/inventoryTypeDetail";

export function InventoryTypeDetail() {
  return (
    <Layout>
      <InventoryTypeDetailContent />
    </Layout>
  );
}
